export default __webpack_public_path__ + "media/images/pause-fc23c939dc01a4c9bca6cab1d2fbc53b.svg";